import * as React from 'react';
import Loadable from 'react-loading-overlay';

import { ILogoVersionInfo, LogoColorVariant } from 'src/App/shared/logo.types';
import LoadingImage from 'src/App/shared/components/gallery/loading-image.component';
import { Markdown } from '../localization/markdown-wrapper';
import { localization } from '../localization/localization';

export interface IConfirmLogoComponentProps {
    logoVersion: ILogoVersionInfo;
    useDarkBackground: boolean;
    disableButtons: boolean;
    showNotAcceptedOverlay?: boolean;
    notAcceptedText?: string;
    onLoadComplete(logoVersion: ILogoVersionInfo, success: boolean): void;
    onConfirmChanged(logoVersion: ILogoVersionInfo, value: boolean): void;
}

export interface IConfirmLogoComponentState {
    isLoading: boolean;
    loadingText?: string;
}

/**
 * Displays logo variant with options Confirm/RequestReview/Reject
 */
export default class ConfirmLogoComponent extends React.PureComponent<IConfirmLogoComponentProps,IConfirmLogoComponentState> {
    constructor(props: IConfirmLogoComponentProps) {
        super(props);

        this.state = {
            isLoading: false
        };
    }

    public onImageLoading() {
        this.setState({
            isLoading: true,
            loadingText: localization.commonLoc.loading
        });
    }

    public onImageLoaded(success: boolean) {
        this.setState({
            isLoading: false,
            loadingText: undefined
        });

        this.props.onLoadComplete(this.props.logoVersion, success);
    }

    private logoVersionToTitle(version: LogoColorVariant): string | JSX.Element {
        switch (version) {
            case LogoColorVariant.normal:
                return <Markdown text={localization.uploadLoc.logoConfirm.variantOrg} />;
            case LogoColorVariant.white:
                return <Markdown text={localization.uploadLoc.logoConfirm.variantWhite} />;
            case LogoColorVariant.black:
                return <Markdown text={localization.uploadLoc.logoConfirm.variantBlack} />;
        }
    }

    public render() {
        const style: string = 'preview-image ' + (this.props.useDarkBackground ? 'preview-image-dark' : '');

        return (
            <div className="confirm-logo-root">
                <div className="row-title">
                    <span className="primary-color">{this.logoVersionToTitle(this.props.logoVersion.variant)}</span>
                </div>
                <div className="row-content">
                    <Loadable
                        active={this.state.isLoading}
                        spinner={true}
                        text={this.state.loadingText}
                        fadeSpeed={0}
                        >
                        <div className={style}>
                            <LoadingImage
                                src={this.props.logoVersion.src}
                                onLoadStarted={() => this.onImageLoading() }
                                onLoadCompleted={res => this.onImageLoaded(res)}
                            />                            
                            <div className="preview-image-overlay" style={{opacity: this.props.showNotAcceptedOverlay ? 1 : 0}}>
                                <div className="preview-image-overlay-text"><Markdown text={this.props.notAcceptedText as string} /></div>
                            </div>
                        </div>
                    </Loadable>
                </div>
                <div className="row-buttons">
                    <button className={(this.props.logoVersion.accept ? 'btn-ok' : '')}
                            onClick={() => this.props.onConfirmChanged(this.props.logoVersion, true)}
                            disabled={this.props.disableButtons}>
                            <div className="btn-icon-with-text">
                                {/* <CheckIcon /> */}
                                <span><Markdown text={localization.uploadLoc.logoConfirm.logoOk} /></span>
                            </div>
                    </button>
                    <button className={(this.props.logoVersion.accept ? '' : 'btn-wrong')} 
                            onClick={() => this.props.onConfirmChanged(this.props.logoVersion, false)}
                            disabled={this.props.disableButtons}>
                            <div className="btn-icon-with-text">
                                {/* <CheckIcon /> */}
                                <span><Markdown text={localization.uploadLoc.logoConfirm.logoWrong} /></span>
                            </div>
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/confirm-logo.component.tsx